import React from "react";
import { Route } from "react-router-dom";
import useUserStore from "../../stores/user";
import NotFound from "../NotFound";

// Strict entity-super-admin-only gate. Use for routes that must remain
// locked to PaymentCloud / EMS / KurvPay admins even though EntityAdminRoute
// has been broadened to also admit dashboard-allowed org admins.
const EntitySuperAdminRoute = ({ component: Component, render, children, ...rest }) => {
  const isEntitySuperAdmin = useUserStore((state) => state.isEntitySuperAdmin);
  const userLoading = useUserStore((state) => state.userLoading);

  if (children) {
    return (
      <Route {...rest}>
        {userLoading ? null : isEntitySuperAdmin ? children : <NotFound />}
      </Route>
    );
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        if (userLoading) {
          return null;
        }
        if (!isEntitySuperAdmin) {
          return <NotFound />;
        }
        if (Component) {
          return <Component {...props} />;
        }
        if (render) {
          return render(props);
        }
        return null;
      }}
    />
  );
};

export default EntitySuperAdminRoute;
